import {Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastService} from "../../toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {DataformService} from "../../../services/dataform.service";
import {ComponentsService} from "../../../services/components.service";
import {forkJoin, Subject, takeUntil} from "rxjs";
import {MapSelectionComponent} from "../../map-selection/map-selection.component";
import {ComponentsMaintenanceComponent} from "../../components-maintenance/components-maintenance.component";
import {ComponentModel} from "../../../domain/dao/component.model";
import {SharedComponentsService} from "../../../services/sharedComponents.service";
import {InvalidValuesModel} from "../../../domain/dao/invalid-values.model";
import {InvalidValuesComponent} from "../dialogs/invalid-values/invalid-values.component";
import {HistoricalValuesModel} from "../../../domain/dao/historical-values.model";
import {HistoricalDialogComponent} from "../dialogs/historical-dialog/historical-dialog.component";
import * as FileSaver from 'file-saver';
import {ConfirmDialogService} from "../../../shared/confirm-dialog/ConfirmDialog.service";

@Component({
  selector: 'app-detail-component',
  templateUrl: './detail-component.component.html',
  styleUrls: ['./detail-component.component.css'],
  standalone: false
})
export class DetailComponentComponent implements OnChanges {

  @ViewChild('fileInput', {static: false}) fileInput!: ElementRef;

  @Input() validUser = false;
  @Input() projectId: any;
  @Input() readonly!: boolean;
  @Input() idtareawf: any;
  @Input() typeProcess!: string;
  @Input() username: string = '';
  @Input() language: string = 'IN'
  @Input() process: string = ''

  public form: FormGroup;
  listCampus: any;
  listBuilding: any;
  listFloor: any;
  listRoom: any;
  lstRequestCalls: any = [];
  lstComponent: ComponentModel[] = [];
  location: any = [];
  displayOptionMntCom!: number;
  displayNewComponentBtn!: boolean;

  constructor(private readonly modal: NgbModal,
              private readonly toastService: ToastService,
              private readonly translate: TranslateService,
              private readonly dataFormService: DataformService,
              private readonly fb: FormBuilder,
              private readonly componentService: ComponentsService,
              private readonly confirmService: ConfirmDialogService,
              private readonly sharedComponentsService: SharedComponentsService,
  ) {
    this.form = this.fb.group({});
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['validUser'] && this.validUser) {
      this.listComponent();
      this.displayOptionMntComp();
      this.loadComponents();

    }
  }


  loadComponents() {
    let params = {
      flagAll: 1,
      idioma: this.language,
      idproyecto: this.projectId,
      idtareawf: this.idtareawf,
      user: this.username
    };
    this.dataFormService.listComponent(params).subscribe((data: any) => {
      this.sharedComponentsService.setNewComponents(data.listComponent, this.idtareawf != -1);
    });
  }

  updateComponents() {
    let params = {
      flagAll: 1,
      idioma: this.language,
      idproyecto: this.projectId,
      idtareawf: this.idtareawf
    };
    this.dataFormService.listComponent(params).subscribe((data: any) => {
      this.sharedComponentsService.updateComponents(data.listComponent, this.idtareawf != -1);
    });
  }


  displayOptionMntComp() {
    this.componentService.displayOption(this.projectId, this.idtareawf, this.username).subscribe((data: any) => {
      this.displayOptionMntCom = data?.displayOption;

      this.displayNewComponentBtn = this.displayOptionMntCom != 0 && this.typeProcess == 'PROJECTS';
    });

    

  }


  public listComponent() {
    this.sharedComponentsService.getComponents(this.idtareawf != -1).subscribe((data: any[]) => {

      this.lstComponent = data
      console.log('data1', this.lstComponent)

      let lstRequest: any = {};
      this.lstComponent.forEach(e => {
        e.listComponentGroupAttribute.forEach((x: any) => {
          let paramAttribute = {
            idcomponent: e.idcomponent,
            idgroup: x.attribute_group_id,
            idioma: this.language,
            idTareaWF: this.idtareawf,
            edit: false
          }
          lstRequest[e.idcomponent + '|' + x.attribute_group_id] = this.dataFormService.listComponentAttribute(paramAttribute);
        });
      });

      let lstRequestNoEdit: any = {};
      this.lstComponent.forEach(e => {
        e.listComponentGroupAttribute.forEach((x: any) => {
          let paramAttribute = {
            idcomponent: e.idcomponent,
            idgroup: x.attribute_group_id,
            idioma: this.language,
            idTareaWF: 0,
            edit: true
          }
          lstRequestNoEdit[e.idcomponent + '|' + x.attribute_group_id] = this.dataFormService.listComponentAttribute(paramAttribute);
        });
      });

      forkJoin(lstRequest).subscribe((responses: any) => {
        Object.keys(responses).forEach(key => {
          let keys = key.split('|');
          let component = this.lstComponent.filter(x => x.idcomponent == keys[0])[0];
          let group = component.listComponentGroupAttribute.filter((x: any) => x.attribute_group_id == keys[1])[0];
          group.listComponentAttribute = responses[key];
          group.listComponentAttribute.forEach(attr => {
            if (attr.attribute_type_id === 13) {
              attr.isDragOver = false;
            }
          });
          let paramRequestList: any = {};
          responses[key].forEach((e: any) => {
            if (e.attribute_type_id == 8) {
              this.lstRequestCalls.push({
                url_api: e.url_api,
                header_api: e.header_api,
                body_api: e.body_api,
                type_api: e.type_api,
                list: [e]
              });
              //console.log(e.body_api);
              if (e.label.includes('Campus')) {
                this.dataFormService.getLocations(this.lstRequestCalls[0]).subscribe((result: any) => {
                  if (result.body.executeResponse == 1 && result.body.list.length > 0) {
                    this.listCampus = result.body.list;
                    const loczCampusFound = result.body.list.find((child: any) => child.descripcion == e.valortxt);
                    //console.log(loczCampusFound != null);
                    if (loczCampusFound != null && this.lstRequestCalls.length > 1 && this.lstRequestCalls[1].list[0].label.includes('Building')) {
                      let obj = JSON.parse(this.lstRequestCalls[1].body_api);
                      obj.restrictions.campus.value = loczCampusFound.descripcion;
                      this.lstRequestCalls[1].body_api = JSON.stringify(obj);
                      this.dataFormService.getLocations(this.lstRequestCalls[1]).subscribe((result: any) => {
                        if (result.body.executeResponse == 1 && result.body.list.length > 0) {
                          this.listBuilding = result.body.list;
                          const loczBuildFound = result.body.list.find((child: any) => child.descripcion == this.lstRequestCalls[1].list[0].valortxt);
                          //console.log(loczBuildFound);
                          if (loczBuildFound != null && this.lstRequestCalls.length > 2 && this.lstRequestCalls[2].list[0].label.includes('Floor')) {
                            let obj = JSON.parse(this.lstRequestCalls[2].body_api);
                            obj.restrictions.campus.value = loczCampusFound.descripcion;
                            obj.restrictions.building.value = loczBuildFound.descripcion;
                            this.lstRequestCalls[2].body_api = JSON.stringify(obj);
                            this.dataFormService.getLocations(this.lstRequestCalls[2]).subscribe((result: any) => {
                              if (result.body.executeResponse == 1 && result.body.list.length > 0) {
                                this.listFloor = result.body.list;
                                const loczFloorFound = result.body.list.find((child: any) => child.descripcion == this.lstRequestCalls[2].list[0].valortxt);

                                if (loczFloorFound != null && this.lstRequestCalls.length > 2 && this.lstRequestCalls[3].list[0].label.includes('Room')) {
                                  let obj = JSON.parse(this.lstRequestCalls[3].body_api);
                                  obj.restrictions.campus.value = loczCampusFound.descripcion;
                                  obj.restrictions.building.value = loczBuildFound.descripcion;
                                  obj.restrictions.floor.value = loczFloorFound.descripcion;
                                  this.lstRequestCalls[3].body_api = JSON.stringify(obj);
                                  this.dataFormService.getLocations(this.lstRequestCalls[3]).subscribe((result: any) => {
                                    if (result.body.executeResponse == 1 && result.body.list.length > 0) {
                                      this.listRoom = result.body.list;
                                      const loczRoomFound = result.body.list.find((child: any) => child.descripcion == this.lstRequestCalls[3].list[0].valortxt);
                                    }
                                  });
                                }
                              }
                            });
                          }
                        }
                      });
                    }
                  }
                });
              } else {
                if (e.url_api.includes('Campus')) {
                  this.dataFormService.getLocations(this.lstRequestCalls[0]).subscribe((result: any) => {
                    if (result.body.executeResponse == 1 && result.body.list.length > 0) {
                      this.listCampus = result.body.list;
                    }
                  });
                }
              }
            } else if (e.attribute_type_id == 5 || e.attribute_type_id == 1) {
              let requestList: any = {
                attributeTypeId: e.attribute_type_id,
                idcomponentdet: e.idcomponentdet,
                idioma: this.language
              }
              paramRequestList[e.idcomponentdet] = this.dataFormService.getComponentAttributeList(requestList);
            }
          });
          forkJoin(paramRequestList).subscribe((responseList: any) => {
            Object.keys(responseList).forEach(keyList => {
              let attribute: any = group.listComponentAttribute.filter((x: any) => x.idcomponentdet == keyList)[0];
              attribute.list = responseList[keyList].list;
              console.log('Lista para License Types:', attribute.list);
              let list = attribute.list;
            });
          });
        });
      });

      forkJoin(lstRequestNoEdit).subscribe((responses: any) => {
        Object.keys(responses).forEach(key => {
          let keys = key.split('|');
          let component = this.lstComponent.filter(x => x.idcomponent == keys[0])[0];
          let group = component.listComponentGroupAttribute.filter((x: any) => x.attribute_group_id == keys[1])[0];
          group.listComponentAttributeNoEdit = responses[key];
        });
      });

    });
  }

  /**
   *
   * @param att
   */
  public showMapSelection(att: any) {
    let modalRef = this.modal.open(MapSelectionComponent, {size: 'lg'});
    modalRef.componentInstance.att = att;
    modalRef.result.then((data: any) => {
      console.log(data);
      if (data.valortxt) {
        att.latitude = data.latitud;
        att.longitud = data.longitud;
        att.valortxt = data.valortxt;
      }
    });
  }

  /**
   *
   * @param event
   */
  public changeSelected(event: any) {
    //console.log(event.target.value);
  }

  changeSelections(event: any, option: number) {
    if (option == 1) {
      this.listBuilding = [];
      this.listFloor = [];
      this.listRoom = [];
      this.location.Campus = event.target.value?.split(':')![1].trim();
      if (this.lstRequestCalls.length > 1 && this.lstRequestCalls[1].list[0].label.includes('Building')) {
        let obj = JSON.parse(this.lstRequestCalls[1].body_api);
        obj.restrictions.campus.value = this.location.Campus;
        this.lstRequestCalls[1].body_api = JSON.stringify(obj);
        this.dataFormService.getLocations(this.lstRequestCalls[1]).subscribe((result: any) => {
          if (result.body.executeResponse == 1 && result.body.list.length > 0) {
            this.listBuilding = result.body.list;
          }
        });
      }
    }

    if (option == 2) {
      this.listFloor = [];
      this.listRoom = [];
      this.location.Building = event.target.value?.split(':')![1].trim();
      if (this.lstRequestCalls.length > 2 && this.lstRequestCalls[2].list[0].label.includes('Floor')) {
        let obj = JSON.parse(this.lstRequestCalls[2].body_api);
        obj.restrictions.campus.value = this.location.Campus;
        obj.restrictions.building.value = this.location.Building;
        this.lstRequestCalls[2].body_api = JSON.stringify(obj);
        this.dataFormService.getLocations(this.lstRequestCalls[2]).subscribe((result: any) => {
          if (result.body.executeResponse == 1 && result.body.list.length > 0) {
            this.listFloor = result.body.list;
          }
        });
      }
    }

    if (option == 3) {
      this.listRoom = [];
      this.location.Floor = event.target.value?.split(':')![1].trim();
      if (this.lstRequestCalls.length > 2 && this.lstRequestCalls[3].list[0].label.includes('Room')) {
        let obj = JSON.parse(this.lstRequestCalls[3].body_api);
        obj.restrictions.campus.value = this.location.Campus;
        obj.restrictions.building.value = this.location.Building;
        obj.restrictions.floor.value = this.location.Floor;
        this.lstRequestCalls[3].body_api = JSON.stringify(obj);
        this.dataFormService.getLocations(this.lstRequestCalls[3]).subscribe((result: any) => {
          if (result.body.executeResponse == 1 && result.body.list.length > 0) {
            this.listRoom = result.body.list;
          }
        });
      }
    }
  }

  public save() {
    let list: any = [];
    this.lstComponent.forEach(x => {
      x.listComponentGroupAttribute.forEach((y: any) => {
        y.listComponentAttribute.forEach((z: any) => {
          list.push(z);
        });
      });
    });
    let params = {
      idproyecto: this.projectId,
      idtareawf: this.idtareawf,
      usuario: localStorage.getItem('username'),
      list: list
    };
    this.dataFormService.saveComponentDetail(params).subscribe((data: any) => {
      if (data.body.an_resultado == 0) {
        this.updateComponents();
        this.toastService.show(this.translate.instant('dataform.implementation.tabs.components.update_message'), {type: 'success'});
      } else {
        this.toastService.show(this.translate.instant('dataform.implementation.tabs.components.error_message'), {type: 'error'});
      }
    });
  }

  newComponent() {
    let modalRef = this.modal.open(ComponentsMaintenanceComponent, {size: 'xlg', backdrop: 'static'});
    modalRef.componentInstance.idproyecto = this.projectId;
    modalRef.componentInstance.idioma = this.language;
    modalRef.componentInstance.usuario = this.username;
  }

  onFileSelected(event: any, idcomponentdet: number, prevLoteId: number): void {

    const file = this.getFileFromEvent(event);
    if (file) {
      if (this.isExcelFile(file)) {
        console.log('Archivo válido seleccionado:', file);
        if (prevLoteId !== 0) {
          this.confirmService.confirmDialog(
            this.translate.instant('dataform.implementation.file_upload.confirm_header'),
            this.translate.instant('dataform.implementation.file_upload.confirm_message')
          ).then((confirmed) => {
            if (confirmed && file) {
              this.processFile(file, idcomponentdet, prevLoteId);
            }
          });
        } else {
          this.processFile(file, idcomponentdet, prevLoteId);
        }
      } else {
        this.toastService.show(this.translate.instant('dataform.implementation.file_upload.error_message'), {type: 'error'});
      }
    }
    this.resetFileInput();
  }


  private getFileFromEvent(event: any): File | null {
    if (event.target?.files) {
      return event.target.files[0];
    } else if (event.dataTransfer?.files) {
      return event.dataTransfer.files[0];
    }
    return null;
  }

  private resetFileInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  processFile(file: File, idcomponentdet: number, prevLoteId: number): void {
    this.dataFormService.uploadAndProcessFile(this.projectId, idcomponentdet, prevLoteId, this.username, file, this.language).subscribe({
      next: (response: any) => {
        if (response.an_resultado == 0) {
          this.toastService.show(this.translate.instant('dataform.implementation.file_upload.ok_message'), {type: 'success'});
          setTimeout(() => {
            window.location.reload();
          }, 3000)
        }
        if (response.an_resultado == -2 && response.data.length > 1) {
          this.toastService.show(this.translate.instant('dataform.implementation.file_upload.error_message'), {type: 'error'});
          this.showModalWithInvalidValues(response.data)
        } else {
          console.log("error")
        }
      }, error: (err) => {
        this.toastService.show(this.translate.instant('dataform.implementation.file_upload.error_message'), {type: 'error'});
      }
    })
  }

  isExcelFile(file: File): boolean {
    const validExtensions = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    return validExtensions.includes(file.type);
  }

  showModalWithInvalidValues(invalidValues: InvalidValuesModel[]) {
    const invalidValuesModalRef = this.modal.open(InvalidValuesComponent, {
      size: 'xl'
    });
    invalidValuesModalRef.componentInstance.data = invalidValues;
  }

  downloadTemplate(idcomponentdet: number, loteId: number) {
    const request = {
      componentDetId: idcomponentdet,
      loteId: loteId,
      user: this.username,
      language: this.language
    };
    this.dataFormService.downloadTemplate(request).subscribe({
      next: (response: any) => {
        if (response.an_resultado === 0 && response.data) {
          const byteCharacters = atob(response.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

          const now = new Date();
          const fileName = `SipTrunking_${this.formatDate(now)}.xlsx`;

          FileSaver.saveAs(blob, fileName);
        } else {
          console.error('Error:', response.ac_mensaje);
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}${day}${year}${hours}${minutes}${seconds}`;
  }

  onDragOver(event: any, att: any) {
    event.preventDefault();
    att.isDragOver = true;
  }

  onDragLeave(event: any, att: any): void {
    att.isDragOver = false;
  }

  onDrop(event: any, att: any, componentDet: number, prevLoteId: number) {
    event.preventDefault();
    att.isDragOver = false;
    this.onFileSelected(event, componentDet, prevLoteId);
  }

  triggerFileInput(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  showHistorical(idcomponentdet: number) {
    this.componentService.getHistoric(this.projectId, idcomponentdet).subscribe({
      next: (data: any) => {
        this.showModalWithHistorical(data.data)
        if (data.data && data.data?.length == 0) {
          this.toastService.show(this.translate.instant('dataform.implementation.file_upload.historic_empty'), {type: 'info'});
        }
      }, error: (data: any) => {
        console.error(data);
      }
    })
  }

  showModalWithHistorical(historical: HistoricalValuesModel[]) {
    const invalidValuesModalRef = this.modal.open(HistoricalDialogComponent, {
      size: 'lg'
    });
    invalidValuesModalRef.componentInstance.data = historical;
  }

  isDisabled(att: any): boolean {
     // flagEdit 0 bloquear - flagEdit 1 no bloquear
    return att?.flagEdit == 0;
  }

}
